import { Clickbox, CounterPill, Crumblist, ICrumb, Loading } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import ContentConstants from '../../contentConstants';
import { IBenchmark } from '../../models';
import { SurveyHelper } from '../../utilities';
import { Col3Col9, CrumblistContainer, LabelAbove, LoadingWrapper } from '../common';
import { BenchmarkModal } from './BenchmarkModal';

export interface IBenchmarkSelectorProps {
	availableBenchmarks: IBenchmark[];
	selectedBenchmarkIds: number[];
	descriptionText: string;
	globalTopQuartileId?: number;
	UpdateSelectedBenchmarks: (benchmarkIds: number[]) => void;
	AddBenchmark: (benchmarkId: number) => void;
	RemoveBenchmark: (benchmarkId: number) => void;
	GetMissingBenchmarks: (missingIds: number[]) => void;
	readOnly?: boolean;
}

export interface IBenchmarkSelectorState {
	showBenchmarkModal: boolean;
}

export class BenchmarkSelector extends React.Component<IBenchmarkSelectorProps, IBenchmarkSelectorState> {
	constructor(props: IBenchmarkSelectorProps) {
		super(props);
		this.state = { showBenchmarkModal: false };

		this.handleUpdateBenchmarkCrumbs = this.handleUpdateBenchmarkCrumbs.bind(this);
		this.toggleBenchmarkModal = this.toggleBenchmarkModal.bind(this);
		this.handleMissingBenchmarks = this.handleMissingBenchmarks.bind(this);
	}

	public toggleBenchmarkModal() {
		this.setState({ showBenchmarkModal: !this.state.showBenchmarkModal });
	}
	public handleUpdateBenchmarkCrumbs(benchmarks: ICrumb[]) {
		const benchmarkIds = benchmarks.map((b) => Number(b.value));
		this.props.UpdateSelectedBenchmarks(benchmarkIds);
	}

	public componentDidMount() {
		this.handleMissingBenchmarks();
	}

	public componentDidUpdate(prevProps: IBenchmarkSelectorProps) {
		if (!_.isEqual(prevProps.selectedBenchmarkIds, this.props.selectedBenchmarkIds)) {
			this.handleMissingBenchmarks();
		}
	}

	public render() {
		const { availableBenchmarks, globalTopQuartileId, selectedBenchmarkIds, readOnly } = this.props;
		const selectedBenchmarkCrumbs = SurveyHelper.getCrumbsFromBenchmarks(
			selectedBenchmarkIds,
			availableBenchmarks,
			globalTopQuartileId,
			readOnly,
		);

		return (
			<Col3Col9
				label={ContentConstants.SUBSECTIONHEADERS_BENCHMARKS}
				labelInfo={ContentConstants.INSTRUCTIONALTEXT_CHOSEN_BENCHMARKS}
				labelInfoTitle={ContentConstants.INFOICON_TITLE_BENCHMARKS}
				subLabelDisplayData={<CounterPill actualCount={selectedBenchmarkIds.length} />}
			>
				<LabelAbove type='clickbox' textIsHtml={true} text={this.props.descriptionText} />
				{!readOnly && <Clickbox onClick={this.toggleBenchmarkModal}>{ContentConstants.BENCHMARKS_CLICKBOX_TEXT}</Clickbox>}
				{globalTopQuartileId !== undefined && (
					<BenchmarkModal
						isOpen={this.state.showBenchmarkModal}
						benchmarks={availableBenchmarks}
						globalTopQuartileId={globalTopQuartileId}
						selectedBenchmarkIds={selectedBenchmarkIds}
						toggleModal={this.toggleBenchmarkModal}
						addBenchmark={this.props.AddBenchmark}
						removeBenchmark={this.props.RemoveBenchmark}
					/>
				)}

				{globalTopQuartileId !== undefined && (
					<CrumblistContainer>
						{selectedBenchmarkCrumbs.length > 0 && (
							<Crumblist enableDismiss={true} data={selectedBenchmarkCrumbs} update={this.handleUpdateBenchmarkCrumbs} />
						)}
					</CrumblistContainer>
				)}
				{globalTopQuartileId === undefined && (
					<LoadingWrapper>
						<Loading height='70px' width='70px' />
					</LoadingWrapper>
				)}
			</Col3Col9>
		);
	}

	private handleMissingBenchmarks() {
		const missingBenchmarks = this.props.selectedBenchmarkIds.filter(
			(b) => !this.props.availableBenchmarks.find((ab) => ab.benchmarkId === b),
		);
		if (missingBenchmarks.length > 0) {
			this.props.GetMissingBenchmarks(missingBenchmarks);
		}
	}
}
